import PropTypes from 'prop-types'

import sinfoto from '../../../src/img/sinfoto.jpg'
import { sanitizeImageUrl } from '../../helpers/sanitizeUrl.js'

const normalizarUrl = (url) => sanitizeImageUrl(url?.replaceAll('\\', '/'))

const Imagen = ({ width, height, className = '', adjunto, loadingImagenes }) => {
  return loadingImagenes ? (
    <div className="spinner-border text-secondary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  ) : (
    <img
      src={normalizarUrl(adjunto?.url) || sinfoto}
      width={width}
      height={height}
      loading="lazy"
      alt={adjunto?.nombre || 'Sin foto'}
      className={className}
      onError={(e) => {
        if (e.currentTarget.src !== sinfoto) {
          e.currentTarget.src = sinfoto
        }
      }}
    />
  )
}

Imagen.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  adjunto: PropTypes.shape({
    url: PropTypes.string,
    nombre: PropTypes.string
  }),
  loadingImagenes: PropTypes.bool
}

export default Imagen
